import { getWhatAppRedirectionUrl } from 'src/utils/getWhatsAppRedirectionUrl';

export const sendWhatsappMessage = (message) => {
  const speechInWords = encodeURIComponent(message || '');
  window.open(getWhatAppRedirectionUrl(speechInWords), '_blank');
};
